export { Landing as default } from './Landing'
